import {Component, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {NgClass, NgIf} from "@angular/common";
import {AdminSidebarMenuComponent} from "./sidebar-menu/admin-sidebar-menu.component";
import {AdminMenuService} from "./menu.service";

@Component({
  selector: 'app-admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrl: './admin-sidebar.component.scss',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    AdminSidebarMenuComponent,
    RouterLink
  ]
})
export class AdminSidebarComponent implements OnInit {

  constructor(public menuService: AdminMenuService) {}

  ngOnInit(): void {}

  public toggleSidebar() {
    this.menuService.toggleSidebar();
  }
}
